import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CheckCardBalanceResponse} from '../../model/CheckCardBalanceResponse';
import {CheckCardHistoryResponse} from '../../model/CheckCardHistoryResponse';

@Component({
  selector: 'app-info-display',
  templateUrl: './info-display.component.html',
  styleUrls: ['./info-display.component.css']
})
export class InfoDisplayComponent implements OnInit {

  @Output() hideDataEmitter = new EventEmitter<boolean>();

  @Input('cardBalanceBody') cardBalanceBody: CheckCardBalanceResponse;
  @Input('internetPaymentsActive') internetPaymentsActive: boolean;
  @Input('cardHistoryBody') cardHistoryBody: CheckCardHistoryResponse;

  public smallScreen = false;

  constructor() {
  }

  ngOnInit(): void {
    this.smallScreen = window.innerWidth < 600;
    window.onresize = () => this.smallScreen = window.innerWidth < 600;
  }

  public hideData(): void {
    this.hideDataEmitter.emit(false);
  }

  checkTransactionType(type): boolean {
    return type !== 'sprzedaż';
  }

  formatDate(date): string {
    return date.substring(0, 10);
  }

  getMainAmount(balance: string): string {
    if (balance.includes('.')) {
      return balance.substring(0, balance.indexOf('.'));
    } else {
      return balance;
    }
  }

  getRestAmount(balance: string): string {
    if (balance.includes('.')) {
      return balance.substring(balance.indexOf('.') + 1, balance.length);
    } else {
      return '00';
    }
  }
}
